export default "__VITE_ASSET__DdJesl72__"